import request from '../utils/request'
import global from '../config/global'

function list(params = {}) {
  return request({
    url: global.endpoint.PROJECTS,
    method: 'get',
    params
  })
}

async function get_payload(value, workspaceId) {
  const shareKey = await global.jsCore.cryptoService.makeShareKey()
  return {
    ...value,
    organization_id: workspaceId,
    key: shareKey[0].encryptedString,
  }
}

function get(id, params = {}) {
  return request({
    url: global.endpoint.PROJECT.replace(':id', id),
    method: 'get',
    params
  })
}

function create(data = {}) {
  return request({
    url: global.endpoint.PROJECTS,
    method: 'post',
    data
  })
}

function update(id, data = {}) {
  return request({
    url: global.endpoint.PROJECT.replace(':id', id),
    method: 'put',
    data
  })
}

function remove(id) {
  return request({
    url: global.endpoint.PROJECT.replace(':id', id),
    method: 'delete',
  })
}

function remove_projects(ids) {
  return request({
    url: global.endpoint.PROJECTS_DELETE,
    method: 'post',
    data: { ids }
  })
}

function access_logs(id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_ACCESS_LOGS.replace(':id', id),
    method: 'get',
    params
  })
}

function members(id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_MEMBERS.replace(':id', id),
    method: 'get',
    params
  })
}

function create_member(id, data) {
  return request({
    url: global.endpoint.PROJECT_MEMBERS.replace(':id', id),
    method: 'post',
    data
  })
}

async function create_members(id, data) {
  return request({
    url: global.endpoint.PROJECT_CREATE_MEMBERS.replace(':id', id),
    method: 'post',
    data: data
  })
}

function update_member(id, memberId, data) {
  return request({
    url: global.endpoint.PROJECT_MEMBER.replace(':id', id).replace(':member_id', memberId),
    method: 'put',
    data
  })
}

function remove_member(id, memberId) {
  return request({
    url: global.endpoint.PROJECT_MEMBER.replace(':id', id).replace(':member_id', memberId),
    method: 'delete',
  })
}


export default {
  list,
  get_payload,
  get,
  create,
  update,
  remove,
  remove_projects,
  access_logs,
  members,
  create_member,
  create_members,
  update_member,
  remove_member
}
